import React from "react";
import profile_Img from "../../../../Assets/Images/multipleUsers.png";

export default function GroupHeader({
  setShowProfileView,
  groupActiveChat,
  setActiveSection,
}) {
  return (
    <div className="px-[10px]  flex justify-between items-center w-full">
      <div
        onClick={() => {
          setActiveSection("contact");
          setShowProfileView(true);
        }}
        className="flex items-center cursor-pointer"
      >
        <div>
          {groupActiveChat?.avtarImage ||
            groupActiveChat?.mediaId?.imageUrl ||
            groupActiveChat?.mediaUrl ? (
            <img
              src={
                groupActiveChat?.avtarImage ||
                groupActiveChat?.mediaId?.imageUrl ||
                groupActiveChat?.mediaUrl
              }
              alt="avatars"
              className="w-[46px] h-[46px] rounded-full object-cover"
            />
          ) : (
            <div
              className="w-[46px] h-[46px] flex items-center justify-center rounded-full shadow-sm"
              style={{
                background:
                  "linear-gradient(to bottom right, rgb(139 92 246), rgb(217 70 239))",
              }}
            >
              <span className="text-white font-bold text-lg">
                {groupActiveChat?.groupName
                  ? groupActiveChat.groupName
                    .split(" ")
                    .map((word) => word[0])
                    .join("")
                    .toUpperCase()
                    .slice(0, 2)
                  : "#"}
              </span>
            </div>
          )}
        </div>
        <div className="flex flex-col justify-start ml-4">
          <span className="text-left cursor-pointer self hover:text-[var(--primary-color)] font-semibold text-sm text-black dark:text-gray-300 pb-1.5">
            {groupActiveChat?.groupName}
          </span>
          <div className="flex items-center space-x-1">
            {/* <span className="w-2 h-2 bg-green-500 rounded-full"></span> */}
            <span className="text-xs font-normal text-[#7C7C7C] line-clamp-2 overflow-hidden text-ellipsis break-words">
              {groupActiveChat?.users?.length} Member
              {groupActiveChat?.users?.length > 1 && "s"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
